import {
  GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  GET_TRIGGER_ORDER_QUOTE_ERROR,
  EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  REQUEST_TARGET_PRICE_AGAIN,
  FINISH_TARGET_PRICE_AGAIN,
} from '../../actions/triggerOrders/triggerOrdersActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  quote: null,
  executedQuote: null,
  errorMessage: '',
  // The latest "Set target price again" request, with its status, or null.
  targetPriceAgain: null,
};

export default createReducer(
  {
    [GET_TRIGGER_ORDER_QUOTE_SUCCESS]: getTriggerOrderQuoteSuccess,
    [GET_TRIGGER_ORDER_QUOTE_ERROR]: triggerOrderQuoteError,
    [EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS]: executeTriggerOrderQuoteSuccess,
    [EXECUTE_TRIGGER_ORDER_QUOTE_ERROR]: triggerOrderQuoteError,
    [REQUEST_TARGET_PRICE_AGAIN]: requestTargetPriceAgain,
    [FINISH_TARGET_PRICE_AGAIN]: finishTargetPriceAgain,
  },
  initialState,
);

function requestTargetPriceAgain(state, action) {
  return {
    ...state,
    targetPriceAgain: action.payload,
  };
}

function finishTargetPriceAgain(state, action) {
  if (!state.targetPriceAgain) {
    return state;
  }

  return {
    ...state,
    targetPriceAgain: { ...state.targetPriceAgain, status: action.payload },
  };
}

function getTriggerOrderQuoteSuccess(state, action) {
  return {
    ...state,
    quote: action.payload,
    errorMessage: '',
  };
}

function executeTriggerOrderQuoteSuccess(state, action) {
  return {
    ...state,
    executedQuote: action.payload,
    errorMessage: '',
  };
}

function triggerOrderQuoteError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}
